"use strict";
// packages/types/src/research.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectEvidenceStatus = exports.ProjectEvidenceType = exports.ResearchActivityType = exports.ProjectStatus = exports.ProjectBillingStatus = void 0;
var ProjectBillingStatus;
(function (ProjectBillingStatus) {
    ProjectBillingStatus["UNPAID"] = "UNPAID";
    ProjectBillingStatus["PAID"] = "PAID";
    ProjectBillingStatus["FAILED"] = "FAILED";
    ProjectBillingStatus["REFUNDED"] = "REFUNDED";
})(ProjectBillingStatus || (exports.ProjectBillingStatus = ProjectBillingStatus = {}));
var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["DRAFT"] = "draft";
    ProjectStatus["ACTIVE"] = "active";
    ProjectStatus["SUBMITTED"] = "submitted";
    ProjectStatus["COMPLETED"] = "completed";
})(ProjectStatus || (exports.ProjectStatus = ProjectStatus = {}));
var ResearchActivityType;
(function (ResearchActivityType) {
    ResearchActivityType["CORE"] = "core";
    ResearchActivityType["SUPPORTING"] = "supporting";
})(ResearchActivityType || (exports.ResearchActivityType = ResearchActivityType = {}));
var ProjectEvidenceType;
(function (ProjectEvidenceType) {
    ProjectEvidenceType["HYPOTHESIS"] = "hypothesis";
    ProjectEvidenceType["TEST_PLAN"] = "test_plan";
    ProjectEvidenceType["EXPERIMENTAL_RESULTS"] = "experimental_results";
    ProjectEvidenceType["LITERATURE_REVIEW"] = "literature_review";
    ProjectEvidenceType["PATENT_SEARCH"] = "patent_search";
    ProjectEvidenceType["TECHNICAL_DOCUMENTATION"] = "technical_documentation";
    ProjectEvidenceType["MEETING_MINUTES"] = "meeting_minutes";
    ProjectEvidenceType["OBSERVATION_LOGS"] = "observation_logs";
    ProjectEvidenceType["DATA_ANALYSIS"] = "data_analysis";
    ProjectEvidenceType["EVALUATION_REPORT"] = "evaluation_report";
    ProjectEvidenceType["BEFORE_AFTER_COMPARISON"] = "before_after_comparison";
    ProjectEvidenceType["OTHER"] = "other";
})(ProjectEvidenceType || (exports.ProjectEvidenceType = ProjectEvidenceType = {}));
var ProjectEvidenceStatus;
(function (ProjectEvidenceStatus) {
    ProjectEvidenceStatus["PENDING"] = "pending";
    ProjectEvidenceStatus["IN_PROGRESS"] = "in_progress";
    ProjectEvidenceStatus["COMPLETED"] = "completed";
})(ProjectEvidenceStatus || (exports.ProjectEvidenceStatus = ProjectEvidenceStatus = {}));
